export default __webpack_public_path__ + "static/media/uploader-medtronic-4.cd5f9a4a.png";